import { RootState } from '@/store'
import { rollbar } from '@/plugins/rollbar'

const setMenus = (state: { menus: any }, payload: any) => {
  state.menus = payload
}

const setMenu = (state: RootState, data: any) => {
  const idx = state.menus.findIndex((menu) => menu.json?.id === data.json?.id)
  if (idx >= 0) {
    state.menus[idx] = data
    state.menus = [...state.menus]
  }
}

const setGetMenuRequestStatus = (state: RootState, value: string) => {
  state.getMenuRequestStatus = value
}

const setBrand = (
  state: { currentBrandId: any; currentBrandName: any; auth: any },
  brandData: { brandName: any; brandId: any }
) => {
  const { brandName, brandId } = brandData
  //
  const brandIsFound = state.auth.brands[brandId] !== undefined
  if (!brandIsFound) {
    rollbar.error('Tried to edit order with brand not found in available brands', brandName, brandId)
  }

  state.currentBrandId = brandId
  state.currentBrandName = brandName
}

const setSource = (state: RootState, source: number) => {
  state.currentSource = source
}

const setStateLoadedFromSession = (state: { stateLoadedFromSession: any }, value: any) => {
  state.stateLoadedFromSession = value
}

const setNewOrdersCount = (state: { newOrdersCount: any }, count: any) => {
  state.newOrdersCount = count
}

const setHalfPizzaSettings = (state: { halfPizzaSettings: any }, value: any) => {
  state.halfPizzaSettings = value
}

const setDelayOrdersListRefresh = (state: { delayOrdersListRefresh: any }, value: any) => {
  state.delayOrdersListRefresh = value
}

const setWindowWidth = (state: { windowWidth: number }, width: number) => {
  state.windowWidth = width
}

export default {
  setMenus,
  setMenu,
  setBrand,
  setSource,
  setStateLoadedFromSession,
  setNewOrdersCount,
  setHalfPizzaSettings,
  setDelayOrdersListRefresh,
  setWindowWidth,
  setGetMenuRequestStatus,
}
